<li class="country-item d-flex justify-content-between align-items-center px-3 py-4" [ngClass]="{'selected fw-bold' : selected }" tabindex="0" (click)="select()" role="option">
    <span class="d-block fs-3">{{ country.name }}</span>
    <span class="d-block fs-3">{{ country.phoneCode }}</span>
</li>